export default __webpack_public_path__ + "static/media/web2.faa0797a.png";